module.exports = __webpack_public_path__ + "img/intro_img.ea13af38.png";